import React from 'react';
import { getBarcode } from '../../../utils/getBarcode';


function VoucherReceipt(props) {

	const style = {
			'textAlign' : 'center'
	}
	return (
		<div style={style}>
			<img src={getBarcode(props.idSource, 1, false)} />
		</div>
	);
}

export default VoucherReceipt;